import Vue from 'vue';
import Vuex from 'vuex';
import {
  getAuthErrorMessage,
  signInWithGoogle,
  signOutUser,
  watchAuthState,
} from '@/services/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null,
    authReady: false,
    authError: '',
  },
  getters: {
    currentUser: (state) => state.currentUser,
    isAuthenticated: (state) => Boolean(state.currentUser),
    authReady: (state) => state.authReady,
    authError: (state) => state.authError,
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setAuthReady(state, isReady) {
      state.authReady = isReady;
    },
    setAuthError(state, message) {
      state.authError = message;
    },
  },
  actions: {
    initializeAuth({ commit }) {
      return watchAuthState(
        (user) => {
          commit('setCurrentUser', user);
          commit('setAuthReady', true);
        },
        (error) => {
          commit('setAuthError', getAuthErrorMessage(error));
          commit('setAuthReady', true);
        },
      );
    },
    async signInWithGoogle({ commit }) {
      commit('setAuthError', '');

      try {
        await signInWithGoogle();
      } catch (error) {
        commit('setAuthError', getAuthErrorMessage(error));
        throw error;
      }
    },
    async signOut({ commit }) {
      commit('setAuthError', '');

      try {
        await signOutUser();
      } catch (error) {
        commit('setAuthError', 'Sign out did not complete. Please try again.');
        throw error;
      }
    },
  },
  modules: {
  },
});
